import device from '../device';
import getUrlInfo from '../getUrlInfo';
import * as moment from 'moment';
import formats from '../../../const/formats';

function getSupportEmailLink(email, project) {
    const subject = 'Alan AI Studio Support';
    const space = '%0D%0A';
    const browserInfo = device.getBrowserInfo();
    const urlInfo = getUrlInfo();
    const currentProjectInfo = project;
    const hasNeededProjectInfo = currentProjectInfo && currentProjectInfo.name && urlInfo.projectName && currentProjectInfo.name === urlInfo.projectName;
    const { dialog, voice } = window.debugInfo;
    const webVersion = window.debugInfo['web version'];

    const bodyLines = [
        `Hi Alan Team,`,
        ``,
        `<--Add your question here -->`,
        ``,
        `Thank you.`,
        ``,
        ``,
        ``,
        ``,
        `Debug Information`,
        `-------`,
        `User email: ${email}`,
    ];

    if (urlInfo.projectName) {
        bodyLines.push(`Project: ${urlInfo.projectName}`);
    }
    if (urlInfo.scriptName) {
        bodyLines.push(`Script: ${urlInfo.scriptName}`);
    }
    if (hasNeededProjectInfo) {
        bodyLines.push(`Created: ${moment(+currentProjectInfo.createTs).format(formats.MM_DD_YYYY_hh_mm_a_for_support)}`);
        bodyLines.push(`Last Update: ${moment(+currentProjectInfo.updateTs).format(formats.MM_DD_YYYY_hh_mm_a_for_support)}`);
    }
    bodyLines.push(`Browser: ${browserInfo.name}`);
    bodyLines.push(`Browser version: ${browserInfo.version}`);
    bodyLines.push(`Screen size: ${browserInfo.screen}`);
    bodyLines.push(`Platform: ${browserInfo.os} ${browserInfo.osVersion}`);
    bodyLines.push(`UserAgent: ${window.navigator.userAgent}`);
    bodyLines.push(`UI language: ${window.navigator.language}`);
    bodyLines.push(`Alan AI Studio version: ${webVersion}`);

    if (dialog) {
        bodyLines.push(`Dialog version: ${dialog}`);
    }
    if (voice) {
        bodyLines.push(`Voice version: ${voice}`);
    }

    const body = bodyLines.join(space);

    return `mailto:support@alan.app?subject=${subject}&body=${body}`;
}

export default getSupportEmailLink;
